import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import styled from "styled-components"
import { Container } from "ui/base/Container"
import { mediaSizes, pageContainerStyles } from "ui/theme"
import { HeaderLogo } from "./components/HeaderLogo"
import { HeaderMenu } from "./components/HeaderMenu"
import { HeaderNavigation } from "./components/HeaderNavigation"

export const HeaderVariant = ({ primary }) => {
  const { pathname } = useLocation()
  const [isAppMode, setIsAppMode] = useState(
    () => new URLSearchParams(window.location.search).get("mode") === "app"
  )

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const mode = params.get("mode")
    setIsAppMode(mode === "app")
  }, [pathname])

  if (isAppMode) return null

  return (
    <HeaderWrapper id="app-header" primary={primary}>
      <Container>
        <HeaderContent>
          <MobileLogo>
            <HeaderLogo
              primary={primary}
              mobile
            />
            <HeaderNavigation
              primary={primary}
              mobile
            />
            <HeaderMenu
              primary={primary}
              mobile
            />
          </MobileLogo>
          <HeaderLogo primary={primary} />
          <HeaderNavigation primary={primary} />
          <HeaderMenu primary={primary} />
        </HeaderContent>
      </Container>
    </HeaderWrapper>
  )
}

const HeaderWrapper = styled.div`
  width: 100%;
  z-index: 99;
  font-family: var(--font-secondary);
  background-color: ${({ primary }) => primary ? "transparent" : "#F7F5F1"};
  ${({ primary }) => primary && `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  `}
`

const HeaderContent = styled.div`
  ${pageContainerStyles}
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding-block: 10px;
  min-height: 50px;
  padding-inline: 0 !important;

  @media (width >= ${mediaSizes.md}) {
    flex-direction: row;
    min-width: 100%;
    justify-content: space-between;
    padding-block: 0;
    min-height: 60px;
    gap: 0;
  }

  @media (width >= ${mediaSizes.lg}) {
    min-height: 64px;
  }
`

const MobileLogo = styled.div`
  display: none;

  @media (max-width: 1023px) {
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`
